/**
 * LES TROIS CHIFFRES QUE LE TABLEAU DE BORD ÉCRIT PLUS GROS QUE TOUT LE RESTE.
 *
 * POURQUOI CE FICHIER EXISTE (2026-09-05). Après le rattachement des 66 tailles de l'écran à
 * l'échelle typographique, il restait quatre valeurs sans cran : 34, 30 et 23 (deux fois). Elles
 * sont bien dans la maquette — vérifié — mais elles n'ont pas leur place dans `TYPE_SCALE`.
 *
 * ⚠️ UNE ÉCHELLE SERT À RÉDUIRE LE NOMBRE DE TAILLES, pas à recenser tout ce qui a été dessiné. La
 * maquette emploie 31 tailles distinctes sur 3 688 déclarations ; les 15 crans en couvrent 96 %. Le
 * reste est une queue de seize valeurs employées une à vingt-sept fois — le résidu d'un dessin fait
 * à la main. Les promouvoir en crans ferait de l'échelle un dictionnaire, et un dictionnaire ne
 * commande rien.
 *
 * ⚠️ CE SONT DONC DES RÔLES DE COMPOSANT, et le dépôt a déjà ce geste : `KPI_TILE.valueSize` vaut
 * 14,5, nommée là où la tuile est définie ; `SEG_THUMB.fontSize` de même. Un rôle nommé se corrige
 * en un endroit et se retrouve par son nom ; un `fontSize: 34` perdu dans 1 700 lignes, non.
 *
 * ⚠️ ET ILS RESTENT DANS LA CHARTE PLUTÔT QUE DANS L'ÉCRAN, pour une raison mesurée pendant cette
 * même session : un jeton posé mais jamais rendu est invisible (`SEG_THUMB`), et une valeur écrite
 * dans un écran est invisible à la charte. Ici l'audit des jetons orphelins vérifie que ces trois-là
 * sont bel et bien lus.
 */

import { TYPE_SCALE } from './theme-web';

/** L'anatomie des grands chiffres du tableau de bord — relevée sur la maquette, jamais arrondie. */
export const DASHBOARD_FIGURES = {
  /**
   * L'ACCROCHE — « Bonjour Claire ».
   * ⚠️ 30 et non `h1` (25) : le dessin fait DÉLIBÉRÉMENT l'accroche plus grande que les titres des
   * autres pages, qui sont bien à 25. C'est la seule page qui s'adresse à quelqu'un.
   */
  // ⚠️ DÉRIVÉ DU CRAN, plus écrit en dur (2026-09-07) : 30 est entré dans `TYPE_SCALE` sous le nom
  // `display` sur décision utilisateur. Le laisser en littéral ici aurait fait DEUX définitions de
  // la même valeur, dont l'une cesserait de suivre l'autre au premier ajustement.
  greetingSize: TYPE_SCALE.display,
  /**
   * LE MONTANT DE LA PÉRIODE — le chiffre d'affaires, en tête de la carte maîtresse.
   * ⚠️ 34 est employé UNE SEULE FOIS dans toute la maquette : c'est le chiffre le plus gros de tout
   * le back-office, et c'est voulu — la page entière existe pour le porter.
   */
  heroAmountSize: 34,
  /** LES DEUX CHIFFRES DE LA TUILE FIDÉLITÉ — acquis et dépensé, à égalité de poids. */
  loyaltyFigureSize: 23,
  /**
   * ⚠️ LE CRÉNAGE FAIT PARTIE DU RÔLE, il ne se recopie pas à côté. Un grand nombre en chiffres
   * tabulaires prend l'air lâche sans resserrement ; c'est ce qui distingue un montant d'un
   * paragraphe grossi.
   */
  greetingTracking: '-0.03em',
  heroAmountTracking: '-0.035em',
  loyaltyFigureTracking: '-0.03em',
} as const;
